// navigator.sendBeacon: analytics and tracking calls, often sent as the page closes.

import { absoluteUrl, bodySummary, shortUrl } from '../net-utils.js';

export function installBeacon(ctx, nav = navigator) {
  const original = nav.sendBeacon;
  if (typeof original !== 'function') return;

  nav.sendBeacon = function sendBeacon(url, data) {
    const queued = original.call(nav, url, data);
    try {
      const href = absoluteUrl(url);
      if (!ctx.busy && !ctx.isOwnUrl(href)) {
        const summary = bodySummary(data, ctx.config.maxBodyLength);
        const detail = ctx.sanitise('network', {
          url: ctx.redact.url(href),
          method: 'POST',
          initiator: 'beacon',
          queued,
          request: ctx.redact.summary(summary),
        });
        if (detail) {
          ctx.push(
            'beacon',
            queued ? 'info' : 'warn',
            `Beacon ${shortUrl(ctx.redact.url(href))}${queued ? '' : ' (not queued)'}`,
            detail,
          );
        }
      }
    } catch {
      // ignore
    }
    return queued;
  };
}
